<template>
  <div class="sc-wrapper">
    <div class="flying" v-bind:style="{ backgroundImage: 'url(' + capKeybd + '), none' }"></div>
    <div class="arrow" v-bind:style="{ backgroundImage: 'url(' + arrow + '), none' }"></div>
    <div class="arrowDraw" v-bind:style="{ backgroundImage: 'url(' + arrowDraw + '), none' }"></div>
    <div class="bullseye" v-bind:style="{ backgroundImage: 'url(' + bullseye + '), none' }"></div>
    <div class="cloud" v-bind:style="{ backgroundImage: 'url(' + bgCloud + '), none' }"></div>
    <div
      class="cloud cloud1"
      v-bind:style="{ backgroundImage: 'url(' + bgCloud + '), none' }"
    ></div>
    <div
      class="cloud cloud2"
      v-bind:style="{ backgroundImage: 'url(' + bgCloud + '), none' }"
    ></div>
    <div class="grass" v-bind:style="{ backgroundImage: 'url(' + bgGrass + '), none' }"></div>
    <intro-button
      class="intro-button"
      :is-loading="isLoading"
      :on-click="playAnimation"
      v-if="!playingAnimation"
      transition="fade"
    ></intro-button>
    <h1 class="activity-title" v-if="!playingAnimation" transition="fade">
      Spot Check
    </h1>
    <h2 class="activity-subtitle" v-if="!playingAnimation" transition="fade">
      {{ activityTitle.display }}
    </h2>
  </div>
</template>

<script>
/* eslint-disable */
import { TweenMax, Sine, Linear } from 'gsap';
import { mapGetters, mapState } from 'vuex';
import Grass from 'images/spotcheck-animation/scGrass.png';
import Cloud from 'images/spotcheck-animation/scCloud.png';
import CapKeybd from 'images/spotcheck-animation/scCapnKeyboard.png';
import Bullseye from 'images/spotcheck-animation/scArrowTarget.png';
import ArrowDraw from 'images/spotcheck-animation/scArrowSequence.png';
import Arrow from 'images/spotcheck-animation/scArrow.png';
import AssetLoader from 'mixins/AssetLoader';
import IntroButton from 'components/buttons/IntroButton.vue';

const { VUE_APP_AUDIO_PREFIX } = process.env;

export default {
  props: {
    onComplete: {
      type: Function,
      default: () => {}
    }
  },

  components: { IntroButton },

  mixins: [AssetLoader],

  data() {
    return {
      bgGrass: Grass,
      bgCloud: Cloud,
      capKeybd: CapKeybd,
      arrowDraw: ArrowDraw,
      arrow: Arrow,
      bullseye: Bullseye,
      sounds: null,
      isLoading: false,
      playingAnimation: false
    };
  },
  computed: {
    ...mapState('application', ['device']),
    ...mapGetters('activity', ['activityTitle'])
  },

  mounted() {
    this.loadAssets();
  },

  methods: {
    async loadSounds() {
      const sounds = [
        'arrow_hitting_target.mp3',
        'arrow_in_flight.mp3',
        'mat_man_flying.mp3',
        'mat_man_pulling_bow.mp3'
      ];
      const spokenWordsPrefix = `${VUE_APP_AUDIO_PREFIX}/words-phrases`;

      const soundArray = sounds.map(sound => `${spokenWordsPrefix}/${sound}`);
      this.queueAudio(soundArray);
      const cache = await this.downloadAudio();

      return {
        sndArrowHit() {
          return cache.get(`${spokenWordsPrefix}/${sounds[0]}`).play();
        },
        sndArrowFly() {
          return cache.get(`${spokenWordsPrefix}/${sounds[1]}`).play();
        },
        sndMMFly() {
          return cache.get(`${spokenWordsPrefix}/${sounds[2]}`).play();
        },
        sndMMBow() {
          return cache.get(`${spokenWordsPrefix}/${sounds[3]}`).play();
        }
      };
    },

    async loadAssets() {
      this.sounds = await this.loadSounds();
      this.isLoading = false;
    },

    playAnimation() {
      this.playingAnimation = true;
      this.$nextTick(() => this.animateFlight());
    },

    animateFlight() {
      TweenMax.set(['.arrowDraw', '.arrow'], { autoAlpha: 0 });
      TweenMax.to('.grass', 5, {
        backgroundPositionX: '-=4096px',
        ease: Sine.easeOut
      });
      TweenMax.to('.cloud', 5, {
        backgroundPositionX: '-=50',
        ease: Sine.easeOut
      });
      TweenMax.from('.bullseye', 1, {
        css: { right: '-100px' },
        delay: 3,
        ease: Linear.easeNone
      });
      TweenMax.to('.flying', 5, {
        bezier: [
          { left: 700, top: 0 },
          { left: 400, top: 150 },
          { left: 200, top: 300 },
          { left: 100, top: 400 },
          { left: 50, top: 435 }
        ],
        ease: Sine.easeIn,
        onComplete: this.animateShot
      });

      TweenMax.set('.flying', {
        scaleX: 0.25,
        scaleY: 0.25
      });

      TweenMax.to('.flying', 4, {
        scaleX: 0.65,
        scaleY: 0.65
      });

      this.sounds.sndMMFly();
    },

    getLeftValueForBullsEye() {
      const bullseye = document.querySelector('.bullseye');
      const { left: bullsEyeLeft } = bullseye.getBoundingClientRect();
      const arrow = document.querySelector('.arrow');
      const scWrapperWidth = document.querySelector('.sc-wrapper').offsetWidth;
      const containerDiff = Math.max((window.innerWidth - scWrapperWidth) / 2, 0);

      if (scWrapperWidth >= window.innerWidth) {
        // no margins to be taken into consideraiton
        return `${bullsEyeLeft - arrow.offsetWidth + bullseye.offsetWidth / 2 - 4}px`;
      }

      // do not take into consideratio margin of container when calculating
      return `${bullsEyeLeft - containerDiff - arrow.offsetWidth + bullseye.offsetWidth / 2 - 4}px`;
    },

    animateShot() {
      TweenMax.set('.flying', { autoAlpha: 0 });
      TweenMax.set(['.arrowDraw', '.arrow'], { autoAlpha: 1 });

      TweenMax.set('.arrowDraw', { backgroundPositionX: '-160px', delay: 1 });
      TweenMax.set('.arrow', { css: { left: '225px' }, delay: 1 });
      TweenMax.delayedCall(0.75, this.sounds.sndMMBow);

      TweenMax.set('.arrowDraw', { backgroundPositionX: '-320px', delay: 1.4 });
      TweenMax.set('.arrow', { css: { left: '203px' }, delay: 1.4 });

      TweenMax.set('.arrowDraw', { backgroundPositionX: '-480px', delay: 1.6 });
      TweenMax.set('.arrow', { css: { left: '192px' }, delay: 1.6 });

      TweenMax.set('.arrowDraw', { backgroundPositionX: '-640px', delay: 2.7 });

      TweenMax.set('.arrowDraw', { backgroundPositionX: '-800px', delay: 2.7 });

      TweenMax.delayedCall(2.7, () => {
        const left = this.getLeftValueForBullsEye();
        TweenMax.set('.arrow', { css: { left } });
      });

      TweenMax.delayedCall(2.7, this.sounds.sndArrowFly);
      TweenMax.delayedCall(2.9, this.sounds.sndArrowHit);
      TweenMax.delayedCall(4, this.onComplete);
    }
  }
};
</script>

<style lang="scss">
@import 'src/assets/sass/fade.scss';
.tablet {
  .sc-wrapper {
    width: 100%;
    height: 100%;
    .bullseye,
    .arrowDraw {
      top: 470px;
    }
    .arrow {
      left: 230px;
      top: 546px;
    }
    .grass {
      width: 100%;
    }
    .cloud,
    .cloud1,
    .cloud2 {
      width: 100%;
    }
  }
}

.sc-wrapper {
  position: relative;
  width: 1024px;
  max-width: 100vw;
  height: 768px;
  overflow: hidden;
  background: #0099ff;
  background: -moz-linear-gradient(top, #0099ff 48%, #99ffff 100%);
  background: -webkit-linear-gradient(top, #0099ff 48%, #99ffff 100%);
  background: linear-gradient(to bottom, #0099ff 48%, #99ffff 100%);
  .arrow {
    width: 139px;
    height: 12px;
    position: absolute;
    left: 235px;
    top: 485px;
    z-index: 500;
  }
  .bullseye {
    width: 94px;
    height: 218px;
    position: absolute;
    right: 90px;
    bottom: 140px;
    z-index: 100;
  }
  .flying {
    width: 273px;
    height: 157px;
    position: absolute;
    left: -273px;
    top: 250px;
    z-index: 400;
  }
  .arrowDraw {
    width: 160px;
    height: 232px;
    background-repeat: no-repeat;
    background-position: 0 0;
    position: absolute;
    left: 150px;
    top: 410px;
    z-index: 400;
  }
  .grass {
    width: 1024px;
    height: 200px;
    background-color: green;
    position: absolute;
    bottom: 0;
  }
  .cloud,
  .cloud1,
  .cloud2 {
    width: 1024px;
    height: 568px;
    background-repeat: no-repeat;
    background-position: 579px 77px;
    position: absolute;
    top: 0;
    display: block;
  }

  .cloud1 {
    background-position: 40px 25px;
  }
  .cloud2 {
    background-position: 740px 175px;
  }

  .activity-title,
  .activity-subtitle {
    display: block;
  }
  .activity-title {
    margin-top: 115px;
  }

  .intro-button {
    position: 'absolute';
    top: 40%;
  }
}
</style>
